import { faSearchDollar } from "@fortawesome/free-solid-svg-icons";
export const traderSelection = {
    name: "Trader Selection",
    minSize: [5, 1],
    icon: faSearchDollar,
    description: "Choose assigned traders(s)",
    defaultConfig: {
        defaultValue: null,
        key: "Trader",
    },
    type: "input",
    category: "dashboard",
};
